import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'pro' | 'enterprise' | null>(null);
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [contactStatus, setContactStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribeStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4p0mj2r20r5k3vfkeag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubscribeStatus('success');
        setEmail('');
        setTimeout(() => setSubscribeStatus('idle'), 3000);
      } else {
        setSubscribeStatus('error');
        setTimeout(() => setSubscribeStatus('idle'), 3000);
      }
    } catch (error) {
      setSubscribeStatus('error');
      setTimeout(() => setSubscribeStatus('idle'), 3000);
    }
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setContactStatus('loading');

    try {
      const form = e.target as HTMLFormElement;
      const formData = new URLSearchParams();
      
      const nameInput = form.elements.namedItem('name') as HTMLInputElement;
      const emailInput = form.elements.namedItem('email') as HTMLInputElement;
      const communityInput = form.elements.namedItem('community') as HTMLInputElement;
      const messageInput = form.elements.namedItem('message') as HTMLTextAreaElement;

      formData.append('name', nameInput.value);
      formData.append('email', emailInput.value);
      formData.append('community', communityInput.value);
      formData.append('message', messageInput.value);

      const response = await fetch('https://readdy.ai/api/form/d4p1hqviu80n4l8qnm20', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setContactStatus('success');
        form.reset();
        setTimeout(() => setContactStatus('idle'), 3000);
      } else {
        setContactStatus('error');
        setTimeout(() => setContactStatus('idle'), 3000);
      }
    } catch (error) {
      setContactStatus('error');
      setTimeout(() => setContactStatus('idle'), 3000);
    }
  };

  const handleRSVP = (eventId: number) => {
    alert('RSVP confirmed! You will receive a confirmation email shortly.');
    setSelectedEvent(null);
  };

  const gossipPosts = [
    {
      id: 1,
      author: 'Sarah M.',
      avatar: 'https://public.readdy.ai/ai/img_res/56760fc88d9ebd3a51192f5f2a88c92b.jpg',
      time: '2 hours ago',
      content: 'Did anyone else see the amazing holiday decorations on Maple Street? The Johnson family really outdid themselves this year! 🎄✨',
      likes: 24,
      comments: 8,
      category: 'Community Events'
    },
    {
      id: 2,
      author: 'Mike R.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20man%20smiling%20headshot%20portrait%20warm%20lighting%20simple%20clean%20background%20natural%20expression%20approachable&width=100&height=100&seq=avatar-mike&orientation=squarish',
      time: '5 hours ago',
      content: 'Heads up neighbors! There\'s a food truck festival happening at the community park this Saturday. The taco truck is supposed to be amazing! 🌮',
      likes: 42,
      comments: 15,
      category: 'Local Events'
    },
    {
      id: 3,
      author: 'Jennifer L.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20woman%20smiling%20headshot%20portrait%20warm%20lighting%20simple%20clean%20background%20natural%20expression%20cheerful&width=100&height=100&seq=avatar-jennifer&orientation=squarish',
      time: '1 day ago',
      content: 'Lost cat found near Oak Avenue! Orange tabby with white paws. Contact me if this is your furry friend. He\'s safe and well-fed! 🐱',
      likes: 67,
      comments: 23,
      category: 'Lost & Found'
    },
    {
      id: 4,
      author: 'David K.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20man%20smiling%20headshot%20portrait%20warm%20lighting%20simple%20clean%20background%20natural%20expression%20confident&width=100&height=100&seq=avatar-david&orientation=squarish',
      time: '1 day ago',
      content: 'Anyone know a good plumber? My kitchen sink is acting up again. Would love a local recommendation! 🔧',
      likes: 18,
      comments: 12,
      category: 'Recommendations'
    },
    {
      id: 5,
      author: 'Emily T.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20woman%20smiling%20headshot%20portrait%20warm%20lighting%20simple%20clean%20background%20natural%20expression%20kind&width=100&height=100&seq=avatar-emily&orientation=squarish',
      time: '2 days ago',
      content: 'The new coffee shop on Main Street is incredible! They have the best lattes and the owner is so friendly. Highly recommend checking it out! ☕',
      likes: 89,
      comments: 31,
      category: 'Local Business'
    },
    {
      id: 6,
      author: 'Robert P.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20man%20smiling%20headshot%20portrait%20warm%20lighting%20simple%20clean%20background%20natural%20expression%20trustworthy&width=100&height=100&seq=avatar-robert&orientation=squarish',
      time: '3 days ago',
      content: 'Reminder: Community garage sale is next weekend! Great opportunity to declutter and find some treasures. See you all there! 🏷️',
      likes: 56,
      comments: 19,
      category: 'Community Events'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20residential%20community%20neighborhood%20aerial%20view%20with%20beautiful%20homes%20green%20spaces%20parks%20and%20tree%20lined%20streets%20showing%20peaceful%20suburban%20living%20with%20warm%20natural%20lighting%20and%20welcoming%20atmosphere%20creating%20sense%20of%20community%20and%20belonging&width=1920&height=1080&seq=hero-neighborhub-bg&orientation=landscape"
            alt="NeighborHub Community"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
          <div className="mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white text-sm font-medium border border-white/20">
              <i className="ri-community-line"></i>
              Welcome to NeighborHub
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Your Community,<br />Connected & Thriving
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            The complete platform for HOA management. Schedule meetings, pay dues, connect with neighbors, and build stronger communities.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/dues"
              className="px-8 py-4 bg-teal-500 text-white rounded-xl font-semibold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Started Today
            </Link>
            <Link
              to="/meetings"
              className="px-8 py-4 bg-white/10 backdrop-blur-md text-white rounded-xl font-semibold hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              View Meetings
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-white/80">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-2xl text-teal-400"></i>
              <span className="text-sm">Secure Payments</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-video-line text-2xl text-teal-400"></i>
              <span className="text-sm">HD Video Meetings</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-check-line text-2xl text-teal-400"></i>
              <span className="text-sm">Easy Scheduling</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Everything You Need to Manage Your HOA</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Powerful features designed to simplify community management and enhance resident engagement
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-calendar-event-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Meeting Management</h3>
              <p className="text-gray-600 leading-relaxed">
                Schedule board meetings, send automated reminders, and track attendance all in one place
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-money-dollar-circle-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Automated Dues Collection</h3>
              <p className="text-gray-600 leading-relaxed">
                Set up recurring payments, send payment reminders, and track dues automatically
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Document Library</h3>
              <p className="text-gray-600 leading-relaxed">
                Store and share important documents, bylaws, and meeting minutes securely
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-notification-3-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Community Announcements</h3>
              <p className="text-gray-600 leading-relaxed">
                Keep residents informed with instant notifications and community updates
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Security & Privacy</h3>
              <p className="text-gray-600 leading-relaxed">
                Bank-level encryption and secure access controls protect your community data
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-bar-chart-box-line text-teal-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Financial Reports</h3>
              <p className="text-gray-600 leading-relaxed">
                Generate detailed financial reports and track community expenses effortlessly
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Built by HOA Board Members, For HOA Board Members
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                We understand the challenges of managing a homeowners association because we've been there. NeighborHub was created out of frustration with outdated, complicated HOA management tools that made simple tasks unnecessarily difficult.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Our mission is simple: make HOA management so easy that board members can focus on building community instead of wrestling with software.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">No Technical Skills Required</h4>
                    <p className="text-gray-600">Designed for real people, not IT professionals</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Transparent Pricing</h4>
                    <p className="text-gray-600">No hidden fees or surprise charges</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Dedicated Support</h4>
                    <p className="text-gray-600">Real humans ready to help when you need it</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20professional%20team%20collaborating%20in%20bright%20office%20space%20with%20laptops%20and%20documents%2C%20diverse%20group%20working%20together%20on%20community%20management%20software%2C%20clean%20minimalist%20workspace%20with%20natural%20lighting%20and%20plants%2C%20professional%20business%20environment%20with%20warm%20atmosphere&width=800&height=600&seq=about-team-image&orientation=landscape"
                  alt="NeighborHub Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                    <i className="ri-community-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-gray-900">500+</div>
                    <div className="text-sm text-gray-600">Communities Served</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Neighborhood Gossip Section */}
      <section id="gossip" className="py-24 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 rounded-full text-amber-700 text-sm font-medium mb-4">
              <i className="ri-chat-smile-3-line"></i>
              What's Happening
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Neighborhood Gossip
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stay in the loop with what's happening in your community. Share updates, recommendations, and connect with neighbors.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {gossipPosts.map((post) => (
              <div key={post.id} className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <img 
                      src={post.avatar} 
                      alt={post.author}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <h4 className="font-semibold text-gray-900">{post.author}</h4>
                      <span className="text-xs text-gray-500 whitespace-nowrap">{post.time}</span>
                    </div>
                    <span className="inline-block px-2 py-1 bg-amber-100 text-amber-700 text-xs rounded-full mt-1">
                      {post.category}
                    </span>
                  </div>
                </div>

                <p className="text-gray-700 leading-relaxed mb-4">
                  {post.content}
                </p>

                <div className="flex items-center gap-6 pt-4 border-t border-gray-100">
                  <button className="flex items-center gap-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                    <i className="ri-heart-line text-lg"></i>
                    <span className="text-sm font-medium">{post.likes}</span>
                  </button>
                  <button className="flex items-center gap-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                    <i className="ri-chat-3-line text-lg"></i>
                    <span className="text-sm font-medium">{post.comments}</span>
                  </button>
                  <button className="flex items-center gap-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer ml-auto">
                    <i className="ri-share-line text-lg"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/signup"
              className="inline-flex items-center gap-2 px-8 py-4 bg-teal-500 text-white rounded-xl font-semibold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-new-line text-xl"></i>
              Join the Conversation
            </Link>
          </div>
        </div>
      </section>

      {/* Calendar Section */}
      <section id="calendar" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Community Calendar</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Stay updated with upcoming events, meetings, and activities in your neighborhood
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Calendar Events */}
            <div className="lg:col-span-2 space-y-6">
              {/* Event 1 */}
              <div 
                onClick={() => setSelectedEvent({
                  id: 1,
                  title: 'HOA Board Meeting',
                  date: '15',
                  month: 'JAN',
                  time: '7:00 PM - 9:00 PM',
                  location: 'Community Center',
                  description: 'Monthly board meeting to discuss community updates, budget review, and upcoming projects.',
                  fullDescription: 'Join us for our monthly HOA Board Meeting where we will discuss important community matters including budget allocations, upcoming maintenance projects, new community guidelines, and resident concerns. All homeowners are welcome to attend and participate in the discussion.',
                  category: 'Meeting',
                  categoryColor: 'bg-teal-500',
                  attending: 32,
                  maxAttendees: 50,
                  agenda: ['Budget Review Q1 2025', 'Pool Renovation Plans', 'Security Updates', 'Resident Q&A'],
                  organizer: 'HOA Board'
                })}
                className="bg-gradient-to-r from-teal-50 to-teal-100 rounded-2xl p-6 border-l-4 border-teal-500 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-teal-500 text-white rounded-xl p-4 text-center min-w-[80px]">
                    <div className="text-2xl font-bold">15</div>
                    <div className="text-sm">JAN</div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">HOA Board Meeting</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        7:00 PM - 9:00 PM
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-map-pin-line"></i>
                        Community Center
                      </span>
                    </div>
                    <p className="text-gray-700 mb-3">
                      Monthly board meeting to discuss community updates, budget review, and upcoming projects.
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-teal-500 text-white text-xs rounded-full">Meeting</span>
                      <span className="text-sm text-gray-600">32 attending</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Event 2 */}
              <div 
                onClick={() => setSelectedEvent({
                  id: 2,
                  title: 'Community Cleanup Day',
                  date: '20',
                  month: 'JAN',
                  time: '9:00 AM - 12:00 PM',
                  location: 'Main Park',
                  description: 'Join your neighbors for a morning of community service. Gloves and supplies provided!',
                  fullDescription: 'Help keep our community beautiful! We will be cleaning common areas, trimming hedges, and planting new flowers. All supplies and refreshments will be provided. This is a great opportunity to meet your neighbors and give back to our community.',
                  category: 'Community Event',
                  categoryColor: 'bg-purple-500',
                  attending: 48,
                  maxAttendees: 75,
                  agenda: ['Common Area Cleanup', 'Garden Maintenance', 'Refreshments & Socializing'],
                  organizer: 'Community Committee'
                })}
                className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-2xl p-6 border-l-4 border-purple-500 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-purple-500 text-white rounded-xl p-4 text-center min-w-[80px]">
                    <div className="text-2xl font-bold">20</div>
                    <div className="text-sm">JAN</div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Community Cleanup Day</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        9:00 AM - 12:00 PM
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-map-pin-line"></i>
                        Main Park
                      </span>
                    </div>
                    <p className="text-gray-700 mb-3">
                      Join your neighbors for a morning of community service. Gloves and supplies provided!
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-purple-500 text-white text-xs rounded-full">Community Event</span>
                      <span className="text-sm text-gray-600">48 attending</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Event 3 */}
              <div 
                onClick={() => setSelectedEvent({
                  id: 3,
                  title: 'Family Movie Night',
                  date: '25',
                  month: 'JAN',
                  time: '6:30 PM - 9:00 PM',
                  location: 'Clubhouse',
                  description: 'Bring your family for a fun movie night! Popcorn and drinks will be provided.',
                  fullDescription: 'Bring your blankets and lawn chairs for a fun family movie night! We will be showing a family-friendly film with free popcorn, drinks, and snacks. Perfect for all ages!',
                  category: 'Social Event',
                  categoryColor: 'bg-rose-500',
                  attending: 65,
                  maxAttendees: 100,
                  agenda: ['Setup at 6:00 PM', 'Movie Starts at 7:00 PM', 'Refreshments Available'],
                  organizer: 'Social Committee'
                })}
                className="bg-gradient-to-r from-rose-50 to-rose-100 rounded-2xl p-6 border-l-4 border-rose-500 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-rose-500 text-white rounded-xl p-4 text-center min-w-[80px]">
                    <div className="text-2xl font-bold">25</div>
                    <div className="text-sm">JAN</div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Family Movie Night</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        6:30 PM - 9:00 PM
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-map-pin-line"></i>
                        Clubhouse
                      </span>
                    </div>
                    <p className="text-gray-700 mb-3">
                      Bring your family for a fun movie night! Popcorn and drinks will be provided.
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-rose-500 text-white text-xs rounded-full">Social Event</span>
                      <span className="text-sm text-gray-600">65 attending</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Event 4 */}
              <div 
                onClick={() => setSelectedEvent({
                  id: 4,
                  title: 'Pool Maintenance Notice',
                  date: '01',
                  month: 'FEB',
                  time: 'All Day',
                  location: 'Community Pool',
                  description: 'Pool will be closed for scheduled maintenance and cleaning. Reopens February 2nd.',
                  fullDescription: 'Our community pool will be closed for routine maintenance including deep cleaning, chemical balancing, equipment inspection, and minor repairs. We apologize for any inconvenience and appreciate your understanding.',
                  category: 'Maintenance',
                  categoryColor: 'bg-blue-500',
                  attending: 0,
                  maxAttendees: null,
                  agenda: ['Deep Cleaning', 'Chemical Treatment', 'Equipment Inspection', 'Safety Check'],
                  organizer: 'Maintenance Team'
                })}
                className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-6 border-l-4 border-blue-500 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-blue-500 text-white rounded-xl p-4 text-center min-w-[80px]">
                    <div className="text-2xl font-bold">01</div>
                    <div className="text-sm">FEB</div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Pool Maintenance Notice</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        All Day
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-map-pin-line"></i>
                        Community Pool
                      </span>
                    </div>
                    <p className="text-gray-700 mb-3">
                      Pool will be closed for scheduled maintenance and cleaning. Reopens February 2nd.
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-blue-500 text-white text-xs rounded-full">Maintenance</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Event 5 */}
              <div 
                onClick={() => setSelectedEvent({
                  id: 5,
                  title: 'Gardening Workshop',
                  date: '10',
                  month: 'FEB',
                  time: '10:00 AM - 12:00 PM',
                  location: 'Community Garden',
                  description: 'Learn sustainable gardening techniques from local experts. Perfect for beginners!',
                  fullDescription: 'Join our expert gardeners for a hands-on workshop covering sustainable gardening practices, composting, seasonal planting, and water conservation. Perfect for beginners and experienced gardeners alike!',
                  category: 'Workshop',
                  categoryColor: 'bg-emerald-500',
                  attending: 28,
                  maxAttendees: 40,
                  agenda: ['Composting Basics', 'Seasonal Planting Guide', 'Water Conservation Tips', 'Q&A Session'],
                  organizer: 'Garden Club'
                })}
                className="bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-2xl p-6 border-l-4 border-emerald-500 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-emerald-500 text-white rounded-xl p-4 text-center min-w-[80px]">
                    <div className="text-2xl font-bold">10</div>
                    <div className="text-sm">FEB</div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Gardening Workshop</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        10:00 AM - 12:00 PM
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-map-pin-line"></i>
                        Community Garden
                      </span>
                    </div>
                    <p className="text-gray-700 mb-3">
                      Learn sustainable gardening techniques from local experts. Perfect for beginners!
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-emerald-500 text-white text-xs rounded-full">Workshop</span>
                      <span className="text-sm text-gray-600">28 attending</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Quick Actions */}
              <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-6 text-white">
                <h3 className="text-xl font-bold mb-4">Quick Actions</h3>
                <div className="space-y-3">
                  <button className="w-full bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
                    <i className="ri-add-line"></i>
                    Add Event
                  </button>
                  <button className="w-full bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
                    <i className="ri-calendar-line"></i>
                    View Full Calendar
                  </button>
                  <button className="w-full bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
                    <i className="ri-notification-line"></i>
                    Event Reminders
                  </button>
                </div>
              </div>

              {/* Upcoming This Week */}
              <div className="bg-gray-50 rounded-2xl p-6">
                <h3 className="font-bold text-gray-900 mb-4">This Week</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
                    <div className="flex-1">
                      <div className="text-sm font-medium text-gray-900">Board Meeting</div>
                      <div className="text-xs text-gray-500">Jan 15, 7:00 PM</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                    <div className="flex-1">
                      <div className="text-sm font-medium text-gray-900">Cleanup Day</div>
                      <div className="text-xs text-gray-500">Jan 20, 9:00 AM</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Event Categories */}
              <div className="bg-white rounded-2xl p-6 border border-gray-200">
                <h3 className="font-bold text-gray-900 mb-4">Event Types</h3>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Meetings</span>
                    <span className="px-2 py-1 bg-teal-100 text-teal-700 text-xs rounded-full">12</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Social Events</span>
                    <span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full">8</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Maintenance</span>
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">5</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Workshops</span>
                    <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs rounded-full">6</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Modal */}
      {selectedEvent && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedEvent(null)}
        >
          <div 
            className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className={`${selectedEvent.categoryColor} text-white p-8 rounded-t-3xl relative`}>
              <button
                onClick={() => setSelectedEvent(null)}
                className="absolute top-6 right-6 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
              <div className="flex items-start gap-6">
                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 text-center min-w-[100px]">
                  <div className="text-4xl font-bold">{selectedEvent.date}</div>
                  <div className="text-lg">{selectedEvent.month}</div>
                </div>
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-sm rounded-full mb-3">
                    {selectedEvent.category}
                  </span>
                  <h2 className="text-3xl font-bold mb-2">{selectedEvent.title}</h2>
                  <div className="flex flex-col gap-2 text-white/90">
                    <div className="flex items-center gap-2">
                      <i className="ri-time-line"></i>
                      <span>{selectedEvent.time}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line"></i>
                      <span>{selectedEvent.location}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-user-line"></i>
                      <span>Organized by {selectedEvent.organizer}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8">
              {/* Description */}
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-3">About This Event</h3>
                <p className="text-gray-700 leading-relaxed">{selectedEvent.fullDescription}</p>
              </div>

              {/* Agenda */}
              {selectedEvent.agenda && selectedEvent.agenda.length > 0 && (
                <div className="mb-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Agenda</h3>
                  <ul className="space-y-2">
                    {selectedEvent.agenda.map((item: string, index: number) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-line text-teal-500 text-xl mt-0.5"></i>
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Attendance Info */}
              {selectedEvent.maxAttendees && (
                <div className="bg-gray-50 rounded-2xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-gray-700 font-medium">Attendance</span>
                    <span className="text-gray-900 font-bold">
                      {selectedEvent.attending} / {selectedEvent.maxAttendees}
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className={`${selectedEvent.categoryColor} h-2 rounded-full transition-all`}
                      style={{ width: `${(selectedEvent.attending / selectedEvent.maxAttendees) * 100}%` }}
                    ></div>
                  </div>
                  <p className="text-sm text-gray-600 mt-2">
                    {selectedEvent.maxAttendees - selectedEvent.attending} spots remaining
                  </p>
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex gap-4">
                {selectedEvent.category !== 'Maintenance' && (
                  <button
                    onClick={() => handleRSVP(selectedEvent.id)}
                    className={`flex-1 ${selectedEvent.categoryColor} text-white py-4 rounded-xl font-medium hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer`}
                  >
                    RSVP for This Event
                  </button>
                )}
                <button
                  className="px-6 py-4 border-2 border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-line"></i>
                </button>
                <button
                  className="px-6 py-4 border-2 border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-share-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pricing Section */}
      <section id="pricing" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Simple, Transparent Pricing
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Choose the perfect plan for your community. No hidden fees, cancel anytime.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Basic Plan */}
            <div className="bg-white rounded-3xl shadow-xl p-8 hover:shadow-2xl transition-shadow">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Basic</h3>
                <div className="flex items-baseline justify-center gap-2 mb-4">
                  <span className="text-5xl font-bold text-gray-900">$49</span>
                  <span className="text-gray-600">/month</span>
                </div>
                <p className="text-gray-600">Perfect for small communities</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Up to 50 members</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Meeting management</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Automated dues collection</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Email support</span>
                </li>
              </ul>
              <a
                href="/signup"
                className="block w-full bg-gray-900 text-white text-center py-4 rounded-xl font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>

            {/* Pro Plan */}
            <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl shadow-2xl p-8 transform scale-105 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-gray-900 px-4 py-1 rounded-full text-sm font-bold">
                MOST POPULAR
              </div>
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-white mb-2">Pro</h3>
                <div className="flex items-baseline justify-center gap-2 mb-4">
                  <span className="text-5xl font-bold text-white">$99</span>
                  <span className="text-teal-100">/month</span>
                </div>
                <p className="text-teal-100">For growing communities</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-white text-xl"></i>
                  <span className="text-white">Up to 200 members</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-white text-xl"></i>
                  <span className="text-white">All Basic features</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-white text-xl"></i>
                  <span className="text-white">Document library</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-white text-xl"></i>
                  <span className="text-white">Financial reports</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-white text-xl"></i>
                  <span className="text-white">Priority support</span>
                </li>
              </ul>
              <a
                href="/signup"
                className="block w-full bg-white text-teal-600 text-center py-4 rounded-xl font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>

            {/* Enterprise Plan */}
            <div className="bg-white rounded-3xl shadow-xl p-8 hover:shadow-2xl transition-shadow">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Enterprise</h3>
                <div className="flex items-baseline justify-center gap-2 mb-4">
                  <span className="text-5xl font-bold text-gray-900">$199</span>
                  <span className="text-gray-600">/month</span>
                </div>
                <p className="text-gray-600">For large communities</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Unlimited members</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">All Pro features</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Custom branding</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">API access</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-teal-500 text-xl"></i>
                  <span className="text-gray-700">Dedicated support</span>
                </li>
              </ul>
              <a
                href="/signup"
                className="block w-full bg-gray-900 text-white text-center py-4 rounded-xl font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Get in Touch
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Have questions? We're here to help. Reach out to our team and we'll get back to you within 24 hours.
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Email Us</h3>
                    <a href="mailto:hello@neighborhub.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                      hello@neighborhub.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Support Hours</h3>
                    <p className="text-gray-600">Monday - Friday: 9am - 6pm EST</p>
                    <p className="text-gray-600">Weekend: 10am - 4pm EST</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Office</h3>
                    <p className="text-gray-600">123 Community Drive</p>
                    <p className="text-gray-600">San Francisco, CA 94102</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-sky-50 rounded-3xl p-8">
              <form onSubmit={handleContactSubmit} className="space-y-6" data-readdy-form id="contact-form">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm"
                    placeholder="John Smith"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm"
                    placeholder="john@example.com"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Community Name
                  </label>
                  <input
                    type="text"
                    name="community"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm"
                    placeholder="Sunset Hills HOA"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm resize-none"
                    placeholder="Tell us how we can help..."
                    required
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
                </div>

                <button
                  type="submit"
                  disabled={contactStatus === 'loading'}
                  className="w-full bg-teal-500 text-white py-4 rounded-xl font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {contactStatus === 'loading' ? 'Sending...' : contactStatus === 'success' ? 'Message Sent!' : contactStatus === 'error' ? 'Try Again' : 'Send Message'}
                </button>

                {contactStatus === 'success' && (
                  <div className="text-center text-teal-600 text-sm font-medium">
                    Thanks! We'll get back to you within 24 hours.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative h-[600px] overflow-hidden">
        <img 
          src="https://readdy.ai/api/search-image?query=modern%20residential%20community%20neighborhood%20aerial%20view%20homes%20green%20spaces%20blue%20sky%20wide%20angle%20panoramic%20professional%20photography%20bright%20daylight&width=1920&height=600&seq=cta-bg&orientation=landscape"
          alt="Community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/30"></div>
        
        <div className="absolute inset-0 flex items-center justify-between px-20">
          <div>
            <h2 className="text-7xl font-bold text-white mb-4 leading-tight" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
              ready to transform<br />
              your community?
            </h2>
          </div>
          
          <div className="text-right">
            <p className="text-xl text-white leading-relaxed mb-2" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
              Join hundreds of HOAs using NeighborHub<br />
              Start your free 30-day trial today
            </p>
          </div>
        </div>
        
        <div className="absolute bottom-24 left-20">
          <Link 
            to="/signup"
            className="inline-flex items-center gap-4 bg-white rounded-full pr-2 pl-8 py-2 shadow-2xl hover:shadow-3xl transition-all cursor-pointer group"
          >
            <span className="text-black text-lg font-medium">Get Started Free</span>
            <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center group-hover:bg-gray-800 transition-colors">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-16">
            {/* Newsletter */}
            <div className="md:col-span-5">
              <h3 className="text-4xl font-light mb-4 leading-tight">
                Stay Connected with<br />Your Community
              </h3>
              <p className="text-gray-400 mb-12">
                Get updates, tips, and community management insights
              </p>
              
              <form onSubmit={handleSubscribe} className="space-y-6" data-readdy-form id="newsletter-subscription">
                <div className="border-b border-white pb-2">
                  <input 
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="w-full bg-transparent text-white placeholder-gray-400 outline-none text-base"
                    required
                  />
                </div>
                
                <button 
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="w-full bg-white text-black px-8 py-4 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {subscribeStatus === 'loading' ? 'Subscribing...' : subscribeStatus === 'success' ? 'Subscribed!' : subscribeStatus === 'error' ? 'Try Again' : 'Subscribe'}
                </button>
              </form>
            </div>

            {/* Quick Links */}
            <div className="md:col-span-3">
              <h4 className="text-sm uppercase tracking-wide text-gray-400 mb-6">Platform</h4>
              <ul className="space-y-4">
                {['Features', 'Pricing', 'AI Assistant', 'Dashboard', 'Pay Dues'].map((item, index) => (
                  <li key={index}>
                    <a href={item === 'Pay Dues' ? '/dues' : `#${item.toLowerCase().replace(' ', '-')}`} className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="md:col-span-4">
              <h4 className="text-sm uppercase tracking-wide text-gray-400 mb-6">Get in Touch</h4>
              <div className="space-y-3 mb-10">
                <p className="text-lg text-white">(555) 123-4567</p>
                <a href="mailto:hello@neighborhub.com" className="text-lg text-white underline hover:text-gray-300 transition-colors cursor-pointer">
                  hello@neighborhub.com
                </a>
              </div>
              
              <h4 className="text-sm uppercase tracking-wide text-gray-400 mb-4">Visit Us</h4>
              <p className="text-gray-400 leading-relaxed">
                123 Innovation Drive<br />
                San Francisco, CA 94105
              </p>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                LinkedIn
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                Twitter
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                Facebook
              </a>
            </div>
            
            <div className="text-sm text-gray-400">
              © 2025 NeighborHub. All rights reserved.
            </div>
            
            <div className="flex items-center gap-6">
              <a href="/privacy" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                Privacy Policy
              </a>
              <a href="/terms" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors underline cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
